<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead> -->
		<div class="mianPage flex_start">
			<div class="leftNav">
				<div class="leftNavTitle">用户角色</div>
				<div class="leftNavRow space_between" :class="{navActive:navTabIndex==index}" @click="navCheck(index)"
					v-for="(item,index) in navList" :key="index">
					<div class="navRowTxt">{{item.roleName}}</div>
					<el-dropdown>
						<div class="navRowIcon"><i class="el-icon-more"></i></div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-hasPermi="['accountManage:roleManage:edit']">
								<div @click="editTableData(item)">编辑</div>
							</el-dropdown-item>
							<el-dropdown-item v-hasPermi="['accountManage:roleManage:delete']">
								<div @click="deleteRole(item)">删除</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="rightMainPage">
				<div class="headTabs">
					<el-tabs v-model="activeTab">
						<el-tab-pane label="功能权限" value="1" name="1"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="space_between">
					<el-button type="primary" @click="menuConfirm" size="small" v-hasPermi="['accountManage:roleManage:save']">保存权限</el-button>
					<el-button type="primary" size="small" @click="addTableData" v-hasPermi="['accountManage:roleManage:add']">
						<i class="el-icon-plus"></i> 新增角色
					</el-button>
				</div>
				<div class="el_tree">
					<!-- :check-strictly="true" @check="checkChange" -->
					<!-- :default-checked-keys="menusChecked" -->
					<!-- @check="treeCheckFun" -->
					<el-tree :data="treeData" show-checkbox node-key="menuId" default-expand-all :props="defaultProps"
						ref="menuTreeRef" @node-expand="nodeExpend">
						<template slot-scope="{ node, data }">
							<div class="custom-tree-node" :class="{
									'level1-node': node.level === 1,
									'level2-node': node.level === 2,
									'level3-node': node.level === 3,
								}">
								<!-- 'is-level3-parent': data.parent && data.parent.menuType === 'C' -->
								<div>{{ node.label }}</div>
							</div>
						</template>
					</el-tree>
				</div>
			</div>
			<el-dialog title="角色管理" :visible.sync="dialogVisible" width="28%">
				<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="appRulesApi" :model="userFormData"
					ref="ruleAPPForm">
					<el-form-item label="角色名称：" prop="roleName">
						<el-input clearable size="small" placeholder="请输入" v-model="userFormData.roleName"></el-input>
					</el-form-item>
					<div class="card-bottom flex_end">
						<el-button @click="closeAPPDialog" size="medium">取消</el-button>
						<el-button type="primary" @click="confirmAPP('ruleAPPForm')" size="medium">确定</el-button>
					</div>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '角色管理',
				hasPermiDict: 'userManage:roleManage:add',
				datePicker: [],
				appSelectData: [], // APP下拉选择列表
				queryData: {
					appId: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				appRulesApi: {
					roleName: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					// forceUpdate: [{
					// 	required: true,
					// 	message: '请选择是否强制更新',
					// 	trigger: 'blur'
					// }],
				},
				userFormData: {}, // 弹框表单信息
				dialogVisible: false, // 弹框显隐
				activeTab: '1',
				navTabIndex: 0,
				menusChecked: [], //菜单默认选中
				// navList: [{
				// 	name: '管理员'
				// }, {
				// 	name: '运营'
				// }, {
				// 	name: '媒介'
				// }, ],
				navList: [],
				treeData: [],
				isTreeCheck: false,
				// treeData: [{
				// 	id: 1,
				// 	label: '一级 1',
				// 	level: 1,
				// 	children: [{
				// 		id: 4,
				// 		label: '二级 1-1',
				// 		level: 2,
				// 		children: [{
				// 			id: 9,
				// 			level: 3,
				// 			label: '三级 1-1-1'
				// 		}, {
				// 			id: 10,
				// 			level: 3,
				// 			label: '三级 1-1-2'
				// 		}]
				// 	}]
				// }, {
				// 	id: 2,
				// 	level: 1,
				// 	label: '一级 2',
				// 	children: [{
				// 		id: 11,
				// 		level: 2,
				// 		label: '二级 2-1',
				// 		children: [{
				// 			id: 10,
				// 			level: 3,
				// 			label: '三级 2-1'
				// 		}, {
				// 			id: 16,
				// 			level: 3,
				// 			label: '三级级 2-2'
				// 		}]
				// 	}, {
				// 		id: 6,
				// 		level: 2,
				// 		label: '二级 2-2'
				// 	}]
				// }, {
				// 	id: 3,
				// 	level: 1,
				// 	label: '一级 3',
				// 	children: [{
				// 		id: 7,
				// 		level: 2,
				// 		label: '二级 3-1'
				// 	}, {
				// 		id: 8,
				// 		level: 2,
				// 		label: '二级 3-2'
				// 	}]
				// }],
				defaultProps: {
					children: 'children',
					label: 'menuName'
				}
			}
		},
		mounted() {
			// this.getAppOption();
			this.getRoleList(true);
			this.$nextTick(() => {
				// this.getMenuList();
				// this.updateTreeStyles();
			})
		},
		methods: {
			// 修改el-tree子集背景颜色及布局
			updateTreeStyles() {
				const level2Nodes = document.getElementsByClassName('level2-node');
				Array.from(level2Nodes).forEach(node => {
					const parentContent = node.closest('.el-tree-node__content');
					if (parentContent) {
						parentContent.style.background = '#F9F9FB';
						// 获取父级.el-tree-node__content的兄弟元素.el-tree-node__children
						const parentNode = parentContent.parentElement;
						const siblingChildren = parentNode.querySelector(':scope > .el-tree-node__children');
						// 判断还有没有子集，没有做出相应处理
						if (siblingChildren) {
							if(window.getComputedStyle(siblingChildren).height == '0px'){
								// 拿到level2-node的祖先元素
								let flexNode = parentNode.parentElement
								// console.log(flexNode);
								parentNode.style.background = '#FFFFFF';
								parentContent.style.background = '#FFFFFF';
								flexNode.style.background = '#FFFFFF';
								flexNode.style.display = 'flex';
								flexNode.style.flexWrap = 'wrap';
							}
						}
					}
				});
				// 修改level3-node的样式保持不变
				const level3Nodes = document.getElementsByClassName('level3-node');
				Array.from(level3Nodes).forEach(node => {
					const parentContent = node.closest('.el-tree-node__content');
					if (parentContent) {
						parentContent.style.background = '#FFFFFF';
					}
				});
			},
			nodeExpend(){
				this.$nextTick(()=>{
					setTimeout(()=>{
						this.updateTreeStyles();
					},50)
				})
			},
			navCheck(index) {
				this.$refs.menuTreeRef.setCheckedKeys([]);
				this.menusChecked = []
				this.navTabIndex = index
				if (this.navList[index].menuIds && this.navList[index].menuIds.length > 0) {
					this.navList[index].menuIds.forEach((v) => {
					  this.$refs.menuTreeRef.setChecked(v, true ,false);
					})
					// let newArr = []
					// this.menusChecked = JSON.parse(JSON.stringify(this.navList[index].menuIds))
					// console.log(this.menusChecked)
					// this.menusChecked.forEach(item => {
					// 	this.hasChecked(item,this.treeData,newArr)
					// })
					// this.menusChecked = newArr
				}
			},
			// treeCheckFun(val, data){
			// 	let checkedNodes = data.checkedNodes;
			// 	if(checkedNodes.length === 0) return;
			// 	this.groupOptionsFun(checkedNodes);
			// },
			// // 添加菜单数据
			// groupOptionsFun(checkedNodes) {
			//   this.menusChecked = [];
			//   checkedNodes.forEach( item => {
			//     let nodesData = item.children;
			//     if(nodesData) return;
			//     if(this.menusChecked.indexOf(item.menuId) === -1 ) {
			//       this.menusChecked.push(item.menuId);
			//     }
			//   })
			// },
			// 树回显处理
			// hasChecked(menuId,data,newArr){
			// 	data.forEach(item => {
			// 	  if (item.menuId == menuId) {
			// 	    if (item.children && item.children.length == 0) {
			// 	      newArr.push(item.menuId);
			// 	    }
			// 	  } else {
			// 	    if (item.children != null && item.children.length != 0) {
			// 	      this.hasChecked(menuId, item.children, newArr);
			// 	    }
			// 	  }
			// 	});
			// },
			// 获取角色列表
			async getRoleList(getMenu = false) {
				let res = await this.$http.get(this.$api.userManage.roleList);
				if (res.code == 1) {
					this.navList = res.data
					if (getMenu) {
						this.getMenuList();
					}
				}
			},
			// 获取菜单列表
			async getMenuList() {
				let res = await this.$http.get(this.$api.userManage.menuList);
				if (res.code == 1) {
					this.treeData = res.data
					this.$nextTick(() => {
						this.navCheck(0);
						this.updateTreeStyles();
					})
				}
			},
			// 菜单权限保存
			async menuConfirm() {
				if (!this.navList || this.navList.length <= 0) return
				let arr = this.getMenuAllCheckedKeys();
				let obj = {
					menuIds: arr
				}
				let data = {
					...this.navList[this.navTabIndex],
					...obj
				}
				let res = await this.$http.post(this.$api.userManage.roleEdit, data);
				if (res.code == 1) {
					this.$message.success('保存成功');
					this.getRoleList();
				}
				// console.log(arr);
				// console.log(this.navList[this.navTabIndex].roleId);
			},
			// 获取菜单节点选中数据
			getMenuAllCheckedKeys() {
				// 目前被选中的菜单节点
				let checkedKeys = this.$refs.menuTreeRef.getCheckedKeys();
				// 半选中的菜单节点
				let halfCheckedKeys = this.$refs.menuTreeRef.getHalfCheckedKeys();
				checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
				return checkedKeys;
			},
			async getAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOption);
				if (res.code == 1) {
					this.appSelectData = res.data
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.datePicker = []
				this.queryData = {
					appId: ''
				}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			// 新增表格信息
			addTableData() {
				this.userFormData = {}
				this.isAdEditDialog = false
				this.dialogVisible = true
			},
			// 编辑表格信息
			editTableData(row) {
				this.userFormData = row
				this.isAdEditDialog = true
				this.dialogVisible = true
			},
			// 删除角色
			deleteRole(item) {
				this.$confirm('此操作将删除该条角色信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = [item.roleId];
					let res = await this.$http.post(this.$api.userManage.roleDelete, data);
					if (res.code == 1) {
						this.$message.success('删除成功');
						this.getRoleList(true); // 刷新
					}
				}).catch();
			},
			// 表格弹窗关闭
			closeAPPDialog() {
				this.dialogVisible = false
			},
			// 弹框提交
			confirmAPP(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.userFormData;
						let res = null
						if (this.userFormData.roleId) {
							res = await this.$http.post(this.$api.userManage.roleEdit, data);
						} else {
							res = await this.$http.post(this.$api.userManage.roleAdd, data);
						}
						if (res.code == 1) {
							if (this.userFormData.roleId) {
								this.$message.success('编辑成功');
							} else {
								this.$message.success('新增成功');
							}
						}
						this.closeAPPDialog();
						this.getRoleList(true);
					}
				});
			},
			// // 通过check的回调里面获取节点id,再获取节点的node对象
			// checkChange(data) {
			// 	//根据key拿到Tree组件中的node节点
			// 	const node = this.$refs.tree.getNode(data.id)
			// 	//调用节点处理方法
			// 	this.setNode(node)
			// },
			// //递归设置子节点和父节点
			// setNode(node) {
			// 	if (node.checked) {
			// 		//如果当前是选中checkbox,则递归设置父节点和父父节点++选中
			// 		this.setParentNode(node)
			// 	} else {
			// 		//如果当前是取消选中checkbox,则递归设置子节点全部取消选中
			// 		this.setChildNode(node)
			// 	}
			// },
			// //递归设置父节点全部选中
			// setParentNode(node) {
			// 	if (node.parent) {
			// 		//循环对象的parent属性，设对象节点选择框为选中状态
			// 		for (const key in node) {
			// 			if (key === 'parent') {
			// 				node[key].checked = true
			// 				//递归调用相应父节点处理函数
			// 				this.setParentNode(node[key])
			// 			}
			// 		}
			// 	}
			// },
			// //递归设置子节点全部取消选中
			// setChildNode(node) {
			// 	if (node.childNodes && node.childNodes.length) {
			// 		//将此节点下所有子节点设为选中状态
			// 		node.childNodes.forEach(item => {
			// 			item.checked = false
			// 			//递归调用相应子节点处理函数
			// 			this.setChildNode(item)
			// 		})
			// 	}
			// },
		},
	}
</script>

<style scoped>
	.mianPage {
		/* margin-top: 3px;
		margin-right: 20px; */
		margin: 10px;
		/* background: #FFFFFF; */
		border-radius: 4px;
		/* padding: 24px; */
	}

	.leftNav {
		height: calc(100vh - 121px);
		width: 180px;
		background: #FFFFFF;
		border-radius: 4px;
		flex-shrink: 0;
	}

	.leftNavTitle {
		font-weight: 500;
		font-size: 12px;
		color: #000000;
		/* text-align: center; */
		padding-left: 20px;
		padding-top: 15px;
		margin-bottom: 15px;
	}

	.leftNavRow {
		width: 156px;
		height: 33px;
		align-items: center;
		margin: 0 auto;
		border-radius: 4px;
		padding: 0 8px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.leftNavRow:hover {
		background: #F2F2F6;
	}

	.navActive {
		background: #F2F2F6;
	}

	.navRowTxt {
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}

	.navRowIcon {
		font-size: 14px;
		color: #666666;
	}

	.rightMainPage {
		flex: 1;
		/* margin: 20px;
		margin-top: 17px; */
		margin-left: 10px;
		padding: 24px;
		padding-top: 10px;
		background: #FFFFFF;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.el_tree {
		margin-top: 15px;
		background: #F1F1F4;
		min-height: 500px;
		border: 1px solid #E3E2E5;
		/* padding: 10px; */
	}

	.el_tree /deep/.el-tree {
		background: #F1F1F4;
		color: #333333;
		font-weight: 500;
		font-size: 12px;
	}

	.custom-tree-node {
		width: 100%;
		height: 100%;
		line-height: 44px;
	}

	.el_tree /deep/.el-tree-node__content {
		height: 44px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		margin-bottom: 22px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}

	.level1-node {}

	.level2-node {
		/* background: #F9F9FB; */
	}

	.level3-node {
		background: #FFFFFF;
	}

	/* 找到 Level 2 的 .el-tree-node__children，并设置 flex */
	/* .level2-node /deep/.el-tree-node__children {
	  display: flex !important;
	  flex-wrap: wrap !important;
	  gap: 8px;
	} */
	/* 穿透修改 Level 2 的 children 容器 */
	/* /deep/ .el-tree-node .is-level3-parent ~ .el-tree-node__children {
	  display: flex;
	  flex-wrap: wrap;
	  gap: 8px;
	} */
	/* 方法一：穿透到最外层容器 */
	/deep/ .el-tree-node__children>.el-tree-node>.el-tree-node__children {
		display: flex;
	  flex-wrap: wrap;
		background: #FFFFFF;
	}
	
	/* // 去掉展开和关闭的动画 */
	/deep/.el-tree .el-tree-node__children {
    transition: none !important; /* 移除所有过渡效果 */
	}
	/* :deep(.el-collapse-transition-leave-active){
	  transition: none;
	} */
</style>